import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=080efe0e"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080efe0e')) {
      api.createRecord('080efe0e', component.options)
    } else {
      api.reload('080efe0e', component.options)
    }
    module.hot.accept("./ResetPasswordForm.vue?vue&type=template&id=080efe0e", function () {
      api.rerender('080efe0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/ResetPasswordForm.vue"
export default component.exports